"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'style.preview.title': 'Style Preview',
    'style.preview.edit': 'Edit Style',
    'style.preview.back': 'Back to List',
};
